import { HStack, VStack } from '@cbhq/cds-web/layout';
import { TextTitle3 } from '@cbhq/cds-web/typography';

import { DashboardProvider } from ':cloud/contexts/DashboardProvider';
import { Chart } from ':cloud/widgets/monitoring/Chart';
import { productCharts } from ':cloud/widgets/monitoring/monitoringConfig';
import { FULL_PAGE_MAX_WIDTH } from ':cloud/widgets/product/constants';

export function OnrampMetrics() {
  return (
    <DashboardProvider>
      <VStack maxWidth={FULL_PAGE_MAX_WIDTH} spacing={10} gap={5} borderedBottom>
        <HStack alignItems="center" gap={2}>
          <TextTitle3 as="h1">Metrics</TextTitle3>
        </HStack>
        <HStack spacingBottom={5} spacingEnd={5} justifyContent="space-evenly" gap={5}>
          <Chart {...productCharts.cbpay.charts[0]} range={30} />
          <Chart {...productCharts.cbpay.charts[1]} range={30} />
        </HStack>
      </VStack>
    </DashboardProvider>
  );
}
